import {parse} from "csv-parse/lib/sync";

export default function(onAdd, onBefore, onAfter) {
    const input = document.createElement('input');
    input.setAttribute('type','file');
    document.body.appendChild(input);
    $(input).on('change', function() {
        if (this.files.length > 0) {
            const file = this.files[0];
            if (file.type === 'text/csv') {
                const reader = new FileReader();
                reader.onloadend = function() {
                    window.updating = true;
                    onBefore()
                    parse(this.result).forEach(row => onAdd(row))
                    window.updating = false;
                    onAfter()
                };
                reader.readAsText(file);

            }
        }
    })
    input.click();
    document.body.removeChild(input);
}
